import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "27",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m16.052 6.7-8.61 8.734a2.87 2.87 0 0 0-.822 2.015c0 .756.296 1.481.823 2.016a2.8 2.8 0 0 0 1.987.834c.745 0 1.46-.3 1.986-.834l8.61-8.734a5.74 5.74 0 0 0 1.646-4.03 5.74 5.74 0 0 0-1.646-4.031A5.58 5.58 0 0 0 16.052 1c-1.49 0-2.92.6-3.973 1.67l-8.61 8.733A8.61 8.61 0 0 0 1 17.45c0 2.268.888 4.443 2.469 6.047A8.37 8.37 0 0 0 9.429 26c2.236 0 4.38-.9 5.961-2.504L24 14.762"
    }, null, -1)
  ]))]))
}
export default { render: render }